import { datadogRum } from '@datadog/browser-rum';
import {
  QueryClient as TanStackQueryClient,
  QueryClientProvider as TanStackQueryClientProvider,
} from '@tanstack/react-query';
import React from 'react';
import { QueryCache, QueryClient, QueryClientProvider } from 'react-query';

const STALE_TIME = 5 * 60 * 1000; // 5 minutes
const CACHE_TIME = 10 * 60 * 1000; // 10 minutes
const GC_TIME = 10 * 60 * 1000; // 10 minutes (v5 uses gcTime instead of cacheTime)

// purge the API cache when app is first loaded
export const queryCache = new QueryCache({
  onError: datadogRum.addError,
});
queryCache.clear();

export interface Props {
  children?: React.ReactNode;
}

const ApiProvider: React.FC<Props> = ({ children }: Props) => {
  const [queryClient] = React.useState(
    new QueryClient({
      defaultOptions: {
        queries: { staleTime: STALE_TIME, cacheTime: CACHE_TIME, refetchOnMount: false, refetchOnWindowFocus: false, retry: false },
      },
    }),
  );

  const [tanstackQueryClient] = React.useState(
    new TanStackQueryClient({
      defaultOptions: {
        queries: { staleTime: STALE_TIME, gcTime: GC_TIME, refetchOnMount: false, refetchOnWindowFocus: false, retry: false },
      },
    }),
  );

  return (
    <QueryClientProvider client={queryClient}>
      <TanStackQueryClientProvider client={tanstackQueryClient}>{children}</TanStackQueryClientProvider>
    </QueryClientProvider>
  );
};

export default ApiProvider;
